import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({ name: 'custom-tag-mixin' })
export default class CustomTag extends Vue {
  @Prop({ type: String, required: false, default: 'div' }) tag!: string
}
